/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-children-prop */
import { SERVICE_PROVIDER_TAGS } from '@amzn/carrier-logistics-common-ui-assets/dist/constants/AppConfig';
import { DEVICE_WIDTHS } from '@amzn/carrierlogistics-commons/dist/constants/breakpoints';
import Column from '@amzn/meridian/column';
import Loader from '@amzn/meridian/loader';
import Responsive from '@amzn/meridian/responsive';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Tag from '@amzn/meridian/tag';
import Text from '@amzn/meridian/text';
import Tooltip from '@amzn/meridian/tooltip';
import { isNull } from 'lodash';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import withIntl from '../../hoc/withIntl';
import useLpSelectActions from '../../hooks/useLpSelectActions';
import NotFoundSvg from '../../images/not-found.svg';
import SelectOptionGroup from '../commons/SelectOptionGroup';

const LpDropdown = () => {
  const { formatMessage } = useIntl();
  const {
    lpData,
    lpIdSelected,
    setLpSelected,
    searchQuery,
    setSearchQuery,
    dspData,
  } = useLpSelectActions();

  return (
    <Responsive
      query="min-width"
      props={{
        width: {
          default: 180,
          [DEVICE_WIDTHS.DESKTOP]: 300,
        },
      }}>
      {({ width }) => (
        <div>
          <Select
            placeholder={formatMessage({ id: 'top_bar.select_lp' })}
            width={width}
            popoverMaxHeight={400}
            value={lpIdSelected}
            onChange={setLpSelected}
            id="lpSelect"
            searchQuery={searchQuery}
            onSearch={setSearchQuery}>
            {lpData?.length === 0 && dspData?.length === 0 && (
              <SelectOption
                label=""
                disabled
                children={() => (
                  <Column alignmentHorizontal="center">
                    <img
                      src={NotFoundSvg}
                      alt={formatMessage({ id: 'lp_dropdown.not_found' })}
                    />
                    <span>
                      <FormattedMessage id="lp_dropdown.not_found" />
                    </span>
                  </Column>
                )}
              />
            )}
            {lpData?.length > 0 && [
              SelectOptionGroup({ label: 'service_provider_type.lp' }),
              ...lpData?.map(({ directedLpId, logisticsPartyDisplayName }) => (
                <SelectOption
                  value={directedLpId}
                  key={directedLpId}
                  label={logisticsPartyDisplayName}
                  children={() => (
                    <div>
                      <span>{logisticsPartyDisplayName}</span>
                    </div>
                  )}
                />
              )),
            ]}
            {dspData?.length > 0 && [
              SelectOptionGroup({ label: 'service_provider_type.dsp' }),
              ...dspData?.map(
                ({
                  directedLpId,
                  logisticsPartyDisplayName,
                  serviceProviderIdentifierType,
                }) => (
                  <SelectOption
                    value={directedLpId}
                    key={directedLpId}
                    label={logisticsPartyDisplayName}
                    children={() => (
                      <Row alignmentHorizontal="justify">
                        <span>{logisticsPartyDisplayName}</span>
                        {SERVICE_PROVIDER_TAGS[
                          serviceProviderIdentifierType
                        ] && (
                          <Tooltip
                            position="top"
                            title={formatMessage({
                              id:
                                SERVICE_PROVIDER_TAGS[
                                  serviceProviderIdentifierType
                                ].tooltip,
                            })}>
                            <Tag />
                          </Tooltip>
                        )}
                      </Row>
                    )}
                  />
                )
              ),
            ]}
            {(isNull(lpData) || isNull(dspData)) && (
              <SelectOption
                label=""
                disabled
                children={() => (
                  <Row alignmentHorizontal="center" minHeight="100px">
                    <Loader
                      type="circular"
                      size="medium"
                      data-testid="lp-loader"
                    />
                    <Text>
                      <FormattedMessage id="top_bar.loading_lps" />
                    </Text>
                  </Row>
                )}
              />
            )}
          </Select>
        </div>
      )}
    </Responsive>
  );
};

export default withIntl(LpDropdown);
